import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import IconButton from '@mui/material/IconButton'

import { Features } from '@app/Feature'
import { isFeatureEnabled } from '@app/Feature/Store/selectors'
import { bemJoin } from '@app/lib/bem'
import { prepareResultsForClipboard } from '@app/modules/Messages/Components/UtilityBillAICheckResults/CheckResults/helper/prepareResultsForClipboard'
import { InvoiceItemsCheckResultsTable } from '@app/modules/Messages/Components/UtilityBillAICheckResults/CheckResults/InvoiceItemsCheckResultsTable'
import { CheckResultsLayout } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsLayout'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'

import './InvoiceItemsCheckResults.scss'

export type InvoiceItemsCheckResultsProps = {
  check: UtilityBillAnalysisChecks['invoiceItems']
}

export const InvoiceItemsCheckResults = ({ check }: InvoiceItemsCheckResultsProps) => {
  const displayNKAResultsCopyButton = useSelector(isFeatureEnabled(Features.COPY_NKA_RESULTS))
  const [showAllResults, setShowAllResults] = useState(false)
  const b = bemJoin('invoice-items-check-results')

  const nkaResultForClipboard = prepareResultsForClipboard(check)

  return (
    <>
      <CheckResultsLayout>
        <CheckResultsLayout.Title>Abrechnungsposition</CheckResultsLayout.Title>
        <a onClick={() => setShowAllResults(!showAllResults)} className={b('toggle')}>
          {showAllResults ? 'ausblenden' : 'alle anzeigen'}
        </a>
        {!!displayNKAResultsCopyButton ? (
          <IconButton
            aria-label='copy nka results'
            onClick={() => {
              navigator.clipboard.writeText(nkaResultForClipboard)
            }}
            sx={{ height: '1.2em', width: '1.2em', marginLeft: '.5em' }}
          >
            <ContentCopyIcon sx={{ height: '.7em', width: '.7em' }} />
          </IconButton>
        ) : null}
        {showAllResults ? (
          <CheckResultsLayout.Description>
            Fragwürdig = eine weitergehende Prüfung mitsamt Belegeinsicht wird empfohlen. Die
            entsprechende Position könnte in Teilen oder ganz nicht umlagefähig sein. Nicht okay =
            nicht in Nebenkostenabrechnung zulässig oder umlegbar.
          </CheckResultsLayout.Description>
        ) : null}
        <InvoiceItemsCheckResultsTable rows={check.children} showAllResults={showAllResults} />
      </CheckResultsLayout>
    </>
  )
}
